import httpClient from '../../services/httpClient'
import api from '../../services/api'
import { User } from '../../pages/preferences/types'
import { ResponseModel } from '../../data/types'

export const getUser = async (): Promise<ResponseModel<User> | null> => {
  const { data } = await httpClient.get<ResponseModel<User>>(api.me())
  return data
}
